
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visit/seed",
      function () {
        return require("private-next-pages/visit/seed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visit/seed"])
      });
    }
  